"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppDeployment = void 0;
const getAppDeployment = ({ httpClient, }) => ({ app_id, deployment_id, }) => {
    const path = '/apps';
    const url = `${path}/${app_id}/deployments/${deployment_id}`;
    return httpClient.get(url);
};
exports.getAppDeployment = getAppDeployment;
//# sourceMappingURL=get-app-deployment.js.map